import { jsPDF } from "jspdf";
import { num } from "@/lib/api";

const fmtDate = (s) => new Date(`${s}T12:00:00`).toLocaleDateString("es-CL", { day: "2-digit", month: "long", year: "numeric" });

export function downloadGriReport(rep) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const c = rep.company;
  let y = 0;
  const page = () => { if (y > 270) { doc.addPage(); y = 20; } };
  const header = () => {
    doc.setFillColor(10, 31, 24);
    doc.rect(0, 0, 210, 40, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.setTextColor(244, 247, 246);
    doc.text("TERRA", 20, 20);
    doc.setTextColor(0, 242, 161);
    doc.text("LOOP", 47.5, 20);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(180, 200, 192);
    doc.text("Informe GRI 306: Residuos 2020", 20, 30);
    doc.text(`${fmtDate(rep.periodo.desde)} – ${fmtDate(rep.periodo.hasta)}`, 190, 20, { align: "right" });
    doc.text(`${c.razon_social} · RUT ${c.rut} · ID RETC ${c.id_establecimiento_vu}`, 190, 30, { align: "right" });
    y = 54;
  };
  const title = (t) => {
    page();
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11.5);
    doc.setTextColor(0, 145, 95);
    doc.text(t, 20, y);
    y += 6;
  };
  const para = (t) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(40, 55, 50);
    doc.splitTextToSize(t, 170).forEach((l) => { page(); doc.text(l, 20, y); y += 4.4; });
    y += 4;
  };
  const table = (cols, rows, widths) => {
    const draw = (cells, bold, fill) => {
      const wrapped = cells.map((v, i) => doc.splitTextToSize(String(v ?? "—"), widths[i] - 2));
      const h = Math.max(...wrapped.map((w) => w.length)) * 3.8 + 2.6;
      if (y + h > 282) { doc.addPage(); y = 20; }
      if (fill) { doc.setFillColor(...fill); doc.rect(20, y - 3.6, 170, h, "F"); }
      doc.setFont("helvetica", bold ? "bold" : "normal");
      doc.setTextColor(bold ? 5 : 40, bold ? 19 : 55, bold ? 14 : 50);
      let x = 21;
      wrapped.forEach((w, i) => { doc.text(w, x, y); x += widths[i]; });
      y += h;
    };
    doc.setFontSize(8);
    draw(cols, true, [220, 245, 236]);
    rows.forEach((r, i) => draw(r, false, i % 2 ? null : [246, 248, 247]));
    y += 5;
  };

  header();
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.setTextColor(5, 19, 14);
  doc.text("Informe GRI 306 · Residuos", 20, y);
  y += 8;
  table(["Indicador", "Valor"], [
    ["GRI 306-3 Residuos generados", `${num(rep.gri306_3.total_t, 3)} t`],
    ["GRI 306-4 Residuos desviados de la eliminación", `${num(rep.gri306_4.total_t, 3)} t`],
    ["GRI 306-5 Residuos dirigidos a eliminación", `${num(rep.gri306_5.total_t, 3)} t`],
    ["En gestión (retiro aún no cerrado)", `${num(rep.en_gestion_t, 3)} t`],
    ["Tasa de Desviación Circular (306-4 / 306-3 × 100)", rep.tasa_desviacion == null ? "—" : `${num(rep.tasa_desviacion, 1)} %`],
  ], [120, 50]);

  title("GRI 306-1 · Generación de residuos e impactos significativos");
  para(rep.narrativa.n306_1);
  title("GRI 306-2 · Gestión de impactos significativos");
  para(rep.narrativa.n306_2);

  title("GRI 306-3 · Residuos generados");
  table(["Categoría", "Toneladas"], [["Residuos peligrosos (HAZMAT)", num(rep.gri306_3.peligrosos_t, 3)], ["Residuos no peligrosos", num(rep.gri306_3.no_peligrosos_t, 3)], ["Total", num(rep.gri306_3.total_t, 3)]], [120, 50]);
  table(["Código LER", "Descripción", "Tipo", "Generado (t)"],
    rep.gri306_3.por_ler.map((r) => [r.codigo_ler, r.descripcion, r.peligroso ? "Peligroso" : "No peligroso", num(r.toneladas, 3)]), [24, 96, 26, 24]);

  title("GRI 306-4 · Residuos desviados de la eliminación");
  table(["Operación de valorización", "In-situ (t)", "Off-site (t)", "Total (t)"],
    [...rep.gri306_4.por_operacion.map((o) => [o.operacion, num(o.in_situ_t, 3), num(o.off_site_t, 3), num(o.total_t, 3)]),
      ["Total", num(rep.gri306_4.in_situ_t, 3), num(rep.gri306_4.off_site_t, 3), num(rep.gri306_4.total_t, 3)]], [80, 30, 30, 30]);

  title("GRI 306-5 · Residuos dirigidos a eliminación");
  table(["Destino", "Toneladas"], [["Relleno sanitario / vertedero", num(rep.gri306_5.relleno_t, 3)], ["Incineración sin recuperación de energía", num(rep.gri306_5.incineracion_t, 3)], ["Total", num(rep.gri306_5.total_t, 3)]], [120, 50]);

  title("Respaldo auditable por retiro");
  table(["Certificado", "Fecha", "LER", "t", "Operación", "Gestor · RUT", "ID RETC", "Resolución · CVE"],
    rep.evidencia.map((e) => [e.codigo, e.fecha, e.codigo_ler, num(e.toneladas, 3), e.operacion, `${e.gestor} · ${e.rut_gestor}`, e.retc_gestor, `${e.resolucion || "—"} · ${e.cve || "—"}`]),
    [19, 18, 16, 13, 24, 36, 16, 28]);

  doc.setFontSize(7.5);
  doc.setTextColor(100, 116, 110);
  para(`Notas metodológicas: datos de lotes publicados en terraloop.cl por el establecimiento en el periodo. Peso según báscula calibrada declarada por el generador y peso recibido en destino para retiros cerrados. La operación de valorización se asigna según el código LER. Solo incluye residuos gestionados a través de terraloop.cl; la valorización in-situ y la disposición en relleno fuera de la plataforma no se registran. Cada retiro puede verificarse en ${window.location.origin}/verificar/<certificado>.`);
  doc.save(`informe-gri306-${(c.rut || "").replace(/\W/g, "")}-${rep.periodo.desde}_${rep.periodo.hasta}.pdf`);
}
